import { useCallback, useEffect, useState } from 'react';
import { fetchPublicInfoPage, type InfoPageData, type InfoPageKey } from '../api/infoPages';

export function useManagedInfoPage(pageKey: InfoPageKey) {
  const [data, setData] = useState<InfoPageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const doc = await fetchPublicInfoPage(pageKey);
      setData(doc);
      if (!doc) setError('Page is not available.');
    } catch {
      setError('Failed to load page.');
    } finally {
      setLoading(false);
    }
  }, [pageKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
